export default {
  methods: {
    userIsGuest () {
      return this.$engine.firstOn().user.activeAccount === '3'
    }
  }
}
